// extracted by mini-css-extract-plugin
export default {"root":"CommentContainer_root__767E1","placeHolderShimmer":"CommentContainer_placeHolderShimmer__2DKxx"};